"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RadioGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(RadioGroup, _Component);

  function RadioGroup(props) {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RadioGroup).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "inputs", []);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      return _this.setState({
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRadioFocus", function (focusIndex) {
      return _this.setState({
        focusIndex: focusIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRadioBlur", function () {
      return _this.setState({
        focusIndex: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRadioClick", function (i) {
      var radio = _this.inputs[i];

      if (!radio) {
        return;
      }

      radio.click();
      radio.focus();
    });

    _this.state = {
      value: _this.props.defaultValue
    };
    return _this;
  }

  _createClass(RadioGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      this.inputs = [];

      var _this$props = this.props,
          name = _this$props.name,
          className = _this$props.className,
          defaultValue = _this$props.defaultValue,
          _onChange = _this$props.onChange,
          radios = _this$props.radios,
          other = _objectWithoutProperties(_this$props, ["name", "className", "defaultValue", "onChange", "radios"]); // Hack to prevent ESLint from erroring about this variable not
      // being used. We want to pull it from `props` to ensure it's
      // not passed through to the `<input/>`.


      void defaultValue;
      var radioButtons = radios.map(function (radio, index) {
        var label = radio.label,
            disabled = radio.disabled,
            value = radio.value,
            id = radio.id,
            className = radio.className,
            other = _objectWithoutProperties(radio, ["label", "disabled", "value", "id", "className"]);

        var isChecked = _this2.state.value === value;
        var isFocused = _this2.state.focusIndex === index;
        return _react["default"].createElement("div", {
          className: (0, _classnames["default"])('dqpl-radio-wrap dqpl-flexr', className),
          key: id
        }, _react["default"].createElement("input", _extends({
          type: "radio",
          name: name,
          value: value,
          id: id,
          ref: function ref(input) {
            return _this2.inputs[index] = input;
          },
          onFocus: function onFocus() {
            return _this2.onRadioFocus(index);
          },
          onBlur: function onBlur() {
            return _this2.onRadioBlur();
          },
          onChange: function onChange() {
            _this2.handleChange(value);

            _onChange(radio, _this2.inputs[index]);
          },
          disabled: disabled,
          checked: isChecked
        }, other)), _react["default"].createElement("div", {
          "aria-hidden": "true",
          className: (0, _classnames["default"])('dqpl-radio dqpl-overlay-radio fa', {
            'fa-dot-circle-o': isChecked,
            'fa-circle-o': !isChecked,
            'dqpl-radio-focused': isFocused,
            'dqpl-radio-disabled': disabled
          }),
          onClick: function onClick() {
            return _this2.onRadioClick(index);
          }
        }), _react["default"].createElement("label", {
          htmlFor: id,
          className: (0, _classnames["default"])('dqpl-label', {
            'dqpl-label-disabled': disabled
          })
        }, label));
      });
      return _react["default"].createElement("div", _extends({
        className: (0, _classnames["default"])('dqpl-radio-group', className),
        role: "radiogroup"
      }, other), radioButtons);
    }
  }]);

  return RadioGroup;
}(_react.Component);

exports["default"] = RadioGroup;

_defineProperty(RadioGroup, "propTypes", {
  name: _propTypes["default"].string.isRequired,
  radios: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string.isRequired,
    id: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired
  })).isRequired,
  hasLabel: function hasLabel(props, propName, componentName) {
    if (!props['aria-label'] && !props['aria-labelledby']) {
      return new Error("".concat(componentName, " must have an \"aria-label\" or \"aria-labelledby\" prop"));
    }
  },
  className: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string,
  onChange: _propTypes["default"].func
});

_defineProperty(RadioGroup, "defaultProps", {
  className: '',
  defaultValue: null,
  onChange: function onChange() {}
});